// extracted by mini-css-extract-plugin
module.exports = {"not-found":"_94BXSmv4t7"};